import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import ProductPreorderInfoQuery from 'ggApp/shared/queries/productPreorderInfo.graphql';
import {
    PreorderProductFragment,
    ProductPreorderInfoQuery as ProductPreorderInfoQueryType,
    ProductPreorderInfoQueryVariables,
} from 'ggApp/types/graphql';

export const useProductPreorder = (sku: string, variantId: number) => {
    const [preorderInfo, setPreorderInfo] = useState<PreorderProductFragment>();

    const { data, loading, error } = useQuery<
        ProductPreorderInfoQueryType,
        ProductPreorderInfoQueryVariables
    >(ProductPreorderInfoQuery, {
        variables: {
            productSku: [sku],
        },
    });

    useEffect(() => {
        if (loading && !data) {
            return;
        }

        const currentVariantInfo = data?.products?.[0].variants.find(
            (v) => parseInt(v?.id, 10) === variantId,
        );

        if (currentVariantInfo?.preorder) {
            setPreorderInfo(currentVariantInfo?.preorder);
        }
    }, [loading, data, variantId]);

    if (loading || error) {
        return [];
    }

    return [preorderInfo];
};
